import env from 'react-dotenv';
import { getCookie } from "./helpers";

// Funkcja do dodawania Google Analytics (gtag.js) przez first-party sGTM proxy
export const addGTag = () => {
  const adStorage = getCookie('ad_storage') || 'denied';
  const adUserData = getCookie('ad_user_data') || 'denied';
  const adPersonalization = getCookie('ad_personalization') || 'denied';
  const analyticsStorage = getCookie('analytics_storage') || 'denied';

  // Skrypt inicjalizujący gtag
  const scriptTagInit = document.createElement('script');
  const scriptContent = document.createTextNode(`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('consent', 'default', {
          'ad_storage':'denied',
          'ad_personalization': 'denied',
          'ad_user_data': 'denied',
          'analytics_storage': 'denied',
          wait_for_update: 500
      });

      gtag('set', 'url_passthrough', true);

      gtag('config', '${env.GTAG_ID}', {
          'server_container_url': window.location.origin + '/tr',
          'first_party_collection': true,
          'send_page_view': false
      });
    `);

  // Ładowanie gtag.js przez first-party /tr/ proxy (sGTM)
  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = window.location.origin + '/tr/gtag/js?id=' + env.GTAG_ID;
  document.head.appendChild(gtagScript);

  const consentUpdate = document.createTextNode(`
        gtag('consent', 'update', {
          'ad_storage':'${adStorage}',
          'ad_personalization': '${adPersonalization}',
          'ad_user_data': '${adUserData}',
          'analytics_storage': '${analyticsStorage}'
      });
  `);
  scriptTagInit.appendChild(scriptContent);
  if (adStorage !== 'denied' || adUserData !== 'denied' || adPersonalization !== 'denied' || analyticsStorage !== 'denied') {
    scriptTagInit.appendChild(consentUpdate);
  }
  document.head.appendChild(scriptTagInit);
};
